import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {HomeworkItem, Pagination} from "../../types/student-info/studentsInfoHomeworksShema";


interface HomeworkState {
    items: HomeworkItem[] | null;
     pagination: Pagination,
    isLoading: boolean;
    error: string | null;
}

const initialState: HomeworkState = {
    items: null,
    pagination: {} as Pagination,
    isLoading: true,
    error: null,
};

const homeworkSlice = createSlice({
    name: "homework",
    initialState,
    reducers: {
        setHomeworkData: (state, action) => {
            const {items, pagination} = action.payload;
            state.items = items;
            state.pagination = pagination;
            state.isLoading = false;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
    },
});

export const {
    setHomeworkData,
    setLoading,
    setError,
} = homeworkSlice.actions;

export const homeworkLessonsReducer = homeworkSlice.reducer;